import React, { useEffect, useMemo, useState } from 'react';
import {
    MasterDetailForm,
    Widget, FormInput, FormDatePicker, FormSubmitButton, FormatText, Button
} from '@digital/ui';
import { Collapse, Icon, Divider } from 'antd';
import UploadFile from '@app/components/uploadFile';
import { exportaModelo } from '@app/api/exportaFile';
import { useRecoilState, useRecoilValue } from 'recoil';
import { crfEsin204ViewModelResult, listCrfRegistroEsin204Importacao } from '@app/state/atom';
import { CrfEsin204ViewModel, importacaoPlanilhaCrfEsin204 } from '@app/api/crf/CrfEsin204ContaResultado';
import TabelaRegistroImportacao from './tabelaRegistroImportacao';
import { getAllRegistroCrfEsin204ByEsin204Id } from '@app/api/crf/CrtRegistroEsin204';
import ptBr from '../../../../../../i18n/ptBR/index';
const { Panel } = Collapse;


const CrfEsin204Importacao = () => {

    const [esin204From, setEsin204From] = useRecoilState(crfEsin204ViewModelResult);
    const [listRegistroEsinResult, setListRegistroEsinResult] = useRecoilState(listCrfRegistroEsin204Importacao);
    const [hasFile, setHasFile] = useState(false);
    const exportarModelo = (modelo: string) => {
        if (modelo) {
            exportaModelo(modelo);
        }
    };

    const handPostImportacaoRelatorioiIn204 = (values: CrfEsin204ViewModel) => {
        if (values.formData != undefined && values.formData != null)
            setHasFile(true);

        importacaoPlanilhaCrfEsin204(values, values.formData).then((data) => {
            if (data) {
                if (data.valid) {
                    getAllRegistroEsin();
                }
            }
        });
    }

    useEffect(() => {
        if (esin204From) {
            setHasFile(false);
            getAllRegistroEsin();
        }

    }, [esin204From])

    const getAllRegistroEsin = () => {
        getAllRegistroCrfEsin204ByEsin204Id(
            esin204From.id,
            esin204From.ehContaResultado)
            .then((data) => {
                if (data)
                    setListRegistroEsinResult(data);
            });
    }

    // console.log(esin204From)

    return (
        <>
            <Collapse
                bordered={false}
                defaultActiveKey={['importacaoRelatorioiIn204']}
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                    key="importacaoRelatorioiIn204"
                    header={<span>IMPORTAÇÃO DO RELATÓRIO MRCS105 </span>}
                    style={{ border: 0 }}
                >
                    <MasterDetailForm
                        initialValues={esin204From}
                        onSubmit={handPostImportacaoRelatorioiIn204}>
                        <Widget actions={
                            [
                                // <Button
                                //     type="link"
                                //     icon="files-xls"
                                //     onClick={() => {
                                //         exportarModelo('modeloExecutado');
                                //     }}>
                                //     Modelo de importação executado
                                // </Button>,
                                true && esin204From.totalRegistroEsin204 > 0 && (
                                    <FormSubmitButton
                                        confirm={esin204From.processado ?
                                            ptBr.mensagemProcessado : ptBr.mensagemNaoProcessado}
                                        cancelText={'Não'}
                                        okText={"Sim"}
                                    >
                                        <FormatText id="ui.commons.save" uppercase transform={() => 'IMPORTAR'} />
                                    </FormSubmitButton>
                                ),
                                true && esin204From.totalRegistroEsin204 === 0 && (
                                    <FormSubmitButton
                                        cancelText={'Não'}
                                        okText={"Sim"}
                                    >
                                        <FormatText id="ui.commons.save" uppercase transform={() => 'IMPORTAR'} />
                                    </FormSubmitButton>
                                ),
                            ]
                        }>
                            <FormInput
                                label="Ciclo Orçamentário"
                                name="ano"
                                span={4}
                                disabled />
                            <FormInput
                                label="Mês"
                                name="mes"
                                span={4}
                                disabled />
                            <FormInput
                                label="Status"
                                name="processadoDescricao"
                                span={4}
                                disabled
                            />
                            <FormDatePicker
                                format="DD/MM/YYYY"
                                label="Data início"
                                name="dataInicio"
                                span={4}
                                disabled={true}
                            />
                            <FormDatePicker
                                format="DD/MM/YYYY"
                                label="Data fim"
                                name="dataFim"
                                span={4}
                                disabled={true}
                            />

                            <FormInput
                                label="Valor Total - Importado"
                                name="relatorioVlrTotalFormatado"
                                span={4}
                                disabled
                            />

                            <FormInput
                                label="Valor Total - Importado VRP"
                                name="relatorioTelaVerbaRemanescenteProvisaoTotalFormatado"
                                span={4}
                                disabled
                            />
                            <FormInput
                                label="Valor Total - Consolidado"
                                name="relatorioTotalConsolidadoExecutado"
                                span={4}
                                disabled
                            />

                            <UploadFile
                                hasFile={hasFile}
                                accept=".xlsx"
                                label="Arquivo do relatório"
                                id="importFilePlanilha"
                                selectedItem={esin204From}
                            />
                            {esin204From.processoandoExecutadoMesAno ? (<> <Divider>{esin204From.descricaoProcessoExecutadoMesAno}</Divider> </>) : (<> </>)}
                        </Widget>
                    </MasterDetailForm>
                </Panel>
            </Collapse>

            <TabelaRegistroImportacao />

        </>
    );
};

export default CrfEsin204Importacao;


